import { request } from "@/api/common";
import apis from "@/common/config/host";

const SENDINVOICE = apis.cApiDomain + "/order/sendInvoice";

export const sendInvoice = function (data) {
  return request.post(SENDINVOICE, data);
};
